<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="air-wrap" :class="warningFlagLeft">
        <div class="air-title">南通侧排风</div>
        <div class="air-chart-wrap">
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsLeft1" :series="singleHisDataLeft1"></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsLeft2" :series="singleHisDataLeft2"></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsLeft3" :series="singleHisDataLeft3"></single-histogram>
          </div>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagRight">
        <div class="air-title">常熟侧排风</div>
        <div class="air-chart-wrap">
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsRight1" :series="singleHisDataRight1"></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsRight2" :series="singleHisDataRight2"></single-histogram>
          </div>
          <div class="air-chart">
            <single-histogram :opts="singleHisOptsRight3" :series="singleHisDataRight3"></single-histogram>
          </div>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <SwitchStatus class="switch-item" :title="switchTitleLeft1" :series="switchDataLeft1"></SwitchStatus>
        <SwitchStatus class="switch-item" :title="switchTitleLeft2" :series="switchDataLeft2"></SwitchStatus>
        <RunningTimeBig
          class="running-time-item"
          :title="runningTimeTitleLeft"
          :series="runningTimeDataLeft"
        ></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <SwitchStatus class="switch-item" :title="switchTitleRight1" :series="switchDataRight1"></SwitchStatus>
        <SwitchStatus class="switch-item" :title="switchTitleRight2" :series="switchDataRight2"></SwitchStatus>
        <RunningTimeBig
          class="running-time-item"
          :title="runningTimeTitleRight"
          :series="runningTimeDataRight"
        ></RunningTimeBig>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ventilationNew',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationidLeft: '018ca956-d3f9-4c42-8656-bf704c1d650a',
      stationidRight: '269d3d53-fc75-40f0-b445-ba2bd7a15d0e',
      deviceIdListLeft: [
        {
          deviceId: 'ad9870ad-b897-4189-a897-018122e2c723',
          deviceName: '1#排风机运行'
        },
        {
          deviceId: 'ace13bf9-6c52-4d3a-906c-3fbc44c54185',
          deviceName: '1#排风机故障'
        },
        {
          deviceId: '6f6f051c-0f6d-4c52-9011-80ef1324a342',
          deviceName: '二氧化碳'
        },
        {
          deviceId: '55332b50-daf3-40ef-b71e-642f477c5ad4',
          deviceName: '氧气'
        },
        {
          deviceId: '4825ee51-8a2b-496b-a3d5-9c1fc1775f96',
          deviceName: '一氧化碳'
        },
        {
          deviceId: '85a2ec8b-1fb0-4a66-b4f5-5f8843c3a887',
          deviceName: '1#排风机运行时间'
        }
      ],

      deviceIdListRight: [
        {
          deviceId: 'ba2e389d-23e3-48c0-bf99-5c8551998a08',
          deviceName: '2#排风机运行'
        },
        {
          deviceId: 'cbfc6a7b-e75b-4059-8dcf-d59be6b1efb4',
          deviceName: '2#排风机故障'
        },
        {
          deviceId: 'f6f61d95-7164-4faa-986a-6e87c632ef77',
          deviceName: '二氧化碳'
        },
        {
          deviceId: '9bb4cf05-008f-46a8-9abf-711675232f15',
          deviceName: '氧气'
        },
        {
          deviceId: '3c2dc16f-785a-451e-a3e4-11cd13c25961',
          deviceName: '一氧化碳'
        },
        {
          deviceId: 'a55df504-f42b-4bd7-ae64-f04c6ead88b4',
          deviceName: '2#排风机运行时间'
        }
      ],

      singleHisOptsLeft1: { title: '氧气', histogramName1: '%', max: 22 },
      singleHisOptsLeft2: {
        title: '一氧化碳',
        histogramName1: 'ppm',
        max: 600
      },
      singleHisOptsLeft3: {
        title: '二氧化碳',
        histogramName1: 'ppm',
        max: 800
      },

      singleHisOptsRight1: { title: '氧气', histogramName1: '%', max: 22 },
      singleHisOptsRight2: {
        title: '一氧化碳',
        histogramName1: 'ppm',
        max: 600
      },
      singleHisOptsRight3: {
        title: '二氧化碳',
        histogramName1: 'ppm',
        max: 800
      },

      switchTitleLeft1: '1#排风机运行',
      switchTitleLeft2: '1#排风机故障',
      runningTimeTitleLeft: '1#排风机运行时间',

      switchTitleRight1: '2#排风机运行',
      switchTitleRight2: '2#排风机故障',
      runningTimeTitleRight: '2#排风机运行时间',

      singleHisDataLeft1: {},
      singleHisDataLeft2: {},
      singleHisDataLeft3: {},
      singleHisDataRight1: {},
      singleHisDataRight2: {},
      singleHisDataRight3: {},

      switchDataLeft1: {},
      switchDataLeft2: {},
      switchDataRight1: {},
      switchDataRight2: {},
      runningTimeDataLeft: '',
      runningTimeDataRight: '',

      warningFlagLeft: '',
      warningFlagRight: ''
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.loadingData = true;
      this.getData();
    }
  },
  methods: {
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName, deviceList) {
      const device = deviceList.find(el => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      let requestList = [
        this.getCurrentData(this.stationidLeft),
        this.getCurrentData(this.stationidRight)
      ];
      this.$http.all(requestList).then(
        this.$http.spread((currentDataLeft, currentDataRight) => {
          this.setAirWrapData(
            currentDataLeft.data,
            this.deviceIdListLeft,
            '氧气',
            '一氧化碳',
            '二氧化碳',
            'singleHisDataLeft1',
            'singleHisDataLeft2',
            'singleHisDataLeft3',
            'warningFlagLeft'
          );

          this.setAirWrapData(
            currentDataRight.data,
            this.deviceIdListRight,
            '氧气',
            '一氧化碳',
            '二氧化碳',
            'singleHisDataRight1',
            'singleHisDataRight2',
            'singleHisDataRight3',
            'warningFlagRight'
          );

          const switchIdLeft1 = this.findDeviceId(
            this.switchTitleLeft1,
            this.deviceIdListLeft
          );
          const switchIdLeft2 = this.findDeviceId(
            this.switchTitleLeft2,
            this.deviceIdListLeft
          );
          this.switchDataLeft1 = {
            data: currentDataLeft.data[switchIdLeft1].value,
            isError: currentDataLeft.data[switchIdLeft1].errorLevel
          };
          this.switchDataLeft2 = {
            data: currentDataLeft.data[switchIdLeft2].value,
            isError: currentDataLeft.data[switchIdLeft2].errorLevel,
            isZh: true
          };

          const switchIdRight1 = this.findDeviceId(
            this.switchTitleRight1,
            this.deviceIdListRight
          );
          const switchIdRight2 = this.findDeviceId(
            this.switchTitleRight2,
            this.deviceIdListRight
          );
          this.switchDataRight1 = {
            data: currentDataRight.data[switchIdRight1].value,
            isError: currentDataRight.data[switchIdRight1].errorLevel
          };
          this.switchDataRight2 = {
            data: currentDataRight.data[switchIdRight2].value,
            isError: currentDataRight.data[switchIdRight2].errorLevel,
            isZh: true
          };

          const runningTimeIdLeft = this.findDeviceId(
            this.runningTimeTitleLeft,
            this.deviceIdListLeft
          );
          this.runningTimeDataLeft = currentDataLeft.data[runningTimeIdLeft].value;

          const runningTimeIdRight = this.findDeviceId(
            this.runningTimeTitleRight,
            this.deviceIdListRight
          );
          this.runningTimeDataRight = currentDataRight.data[runningTimeIdRight].value;
        })
      );
    },

    setAirWrapData(
      currentData,
      deviceIdList,
      singleHisDeviceName1,
      singleHisDeviceName2,
      singleHisDeviceName3,
      singleHisDataName1,
      singleHisDataName2,
      singleHisDataName3,
      errorName
    ) {
      const singleHisDeviceId1 = this.findDeviceId(
        singleHisDeviceName1,
        deviceIdList
      );
      const singleHisDeviceId2 = this.findDeviceId(
        singleHisDeviceName2,
        deviceIdList
      );
      const singleHisDeviceId3 = this.findDeviceId(
        singleHisDeviceName3,
        deviceIdList
      );

      this[singleHisDataName1] = {
        data: currentData[singleHisDeviceId1].value
      };
      this[singleHisDataName2] = {
        data: currentData[singleHisDeviceId2].value
      };
      this[singleHisDataName3] = {
        data: currentData[singleHisDeviceId3].value
      };

      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId1].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId2].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId3].errorLevel
      );
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 42px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item {
        height: calc(100% - 110px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;
    }
  }
}
</style>
